import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const TagListing = () => {
    // render
    return (<div></div>);
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

TagListing.propTypes = {};

export { TagListing };

export default TagListing;
